import {createContext} from 'react';
import eventDispatcher from './eventDispatcher';
import {EventDispatcher} from './types';

const EventDispatcherContext = createContext<EventDispatcher>(eventDispatcher);
export default EventDispatcherContext;
